import type { Account } from '@/types/serializers'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface CompanyInformationProps {
  account: Account
}

export default function CompanyInformation({ account }: CompanyInformationProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Company Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {account.website && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Website:</span>
              <a
                href={account.website}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center text-primary hover:text-primary/80 transition-colors text-sm"
              >
                Visit Website
              </a>
            </div>
          )}
          {account.revenue && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Annual Revenue:</span>
              <span className="text-sm font-medium">
                {account.revenue}
              </span>
            </div>
          )}
          {account.headquarters && (
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">Headquarters:</span>
              <span className="text-sm">
                {account.headquarters}
              </span>
            </div>
          )}
          <div className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground">Industry:</span>
            <span className="text-sm font-medium">
              {account.industry}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}